(function ($) {
  $(function () {
    var $videoCardCarouselGroup = $('.video-card-carousel-group');

    if ($videoCardCarouselGroup.length) {
      var videoCardCarouselGroup = (function() {
        var $videoCardCarouselGroupSelect = $videoCardCarouselGroup.find('select');
        var $stickyNav = $(".sticky-nav");
        var hash;

        function storeHashAndRemoveHashFromUrl() {
          // Store the hash value and then remove it from the URL
          hash = window.location.hash;

          if (hash.length) {
            history.replaceState({}, document.title, window.location.pathname);
          }
        }

        function selectBoxIt() {
          $videoCardCarouselGroupSelect.selectBoxIt({
            // Hides the first select box option from appearing when the drop down is opened
            showFirstOption: false,
            width: '100%'
          });
        }

        function handleSelectOptionClick(e, obj) {
          //Do something when the open event is triggered
          var value = obj.selectboxOption[0].value;
          var target = $('#' + value);

          if (target.length) {
            smoothScrollTo(target);
          }
        }

        function getStickyNavHeight() {
          return $stickyNav.length ? $stickyNav.outerHeight() : 0;
        }

        function getMainNavHeight() {
          return !$('header').hasClass('hide-nav') ? $('header').find('.main-nav').outerHeight() : 0;
        }

        function getSecondaryNavHeight() {
          return $('header').find('.secondary-nav').length ? $('header').find('.secondary-nav').outerHeight() : 0;
        }

        function getAnchorOffsetTop(anchor) {
          var $anchor = $(anchor);

          if ($anchor.length) {
            return $anchor.offset().top;
          }
        }

        function smoothScrollTo(el) {
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(el);
          var scrollTopPos = anchorOffsetTop - (getSecondaryNavHeight() + getMainNavHeight() + getStickyNavHeight() + 1);

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() < 1024) {
              scrollTopPos = anchorOffsetTop - (getMainNavHeight() + 1);
            } else {
              scrollTopPos = anchorOffsetTop - (getMainNavHeight() + getSecondaryNavHeight() + 1);
            }
          }

          $('html, body').animate(
            {
              scrollTop: scrollTopPos,
            },
            700,
            function () {
              if (hash.length) {
                history.pushState({}, document.title, hash);
              }
            }
          );
        }

        function smoothScrollOnHash() {
          if (hash.length) {
            smoothScrollTo(hash);
          }
        }

        return {
          init: function () {
            storeHashAndRemoveHashFromUrl();
            selectBoxIt();
            this.bindEvents();
          },
          load: function () {
            smoothScrollOnHash();
          },
          bindEvents: function () {
            $videoCardCarouselGroupSelect.bind({
              "option-click": handleSelectOptionClick
            });
          }
        }
      })();

      videoCardCarouselGroup.init();
      $(window).on('load', videoCardCarouselGroup.load);
    }
  });
})(jQuery);